"use client";

import {
  KanbanBoard,
  KanbanCards,
  KanbanHeader,
  KanbanProvider,
} from "@/components/ui/shadcn-io/kanban";
import type { DragEndEvent } from "@/components/ui/shadcn-io/kanban";
import { FC, PropsWithChildren, useState } from "react";
import { useRefresh } from "react-admin";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import { confirmAssingment } from "@/utils/formChange";

interface Props extends PropsWithChildren {
  statuses: any[];
  resource: string;
}

const CommonKanban: FC<Props> = ({ statuses, resource, children }) => {
  const refresh = useRefresh();
  const [status, setStatus] = useState("");
  const [id, setId] = useState(0);
  const [open, setOpen] = useState(false);

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (!over) {
      return;
    }

    const status = statuses.find((status) => status.name === over.id);

    if (!status) {
      return;
    }

    if (status.name === active.data.current?.parent) return;

    setOpen(true);
    setStatus(status.name);
    setId(+active.id);
  };

  return (
    <>
      <KanbanProvider onDragEnd={handleDragEnd} className="p-4">
        {children}
      </KanbanProvider>
      {open && (
        <ConfirmDialog
          open={open}
          setOpen={setOpen}
          description="Are you sure you want to change the status?"
          setCurrSelected={setStatus}
          confirmAssignment={() =>
            confirmAssingment(
              "status",
              status,
              resource,
              id,
              "updateStatus",
              refresh,
              setOpen,
            )
          }
        />
      )}
    </>
  );
};

export default CommonKanban;
